import React from "react";
import styled from "styled-components";
import { Panel } from "components/bootstrap";
import { Icon } from "components/common";
import styles from "./HelpPanel.css";
const IconHeader = styled(Icon)`
  margin-right: 9px;
`;
const ConditionalCollapse = ({ condition, wrapper, children }) => condition ? wrapper(children) : children;
export const HelpPanel = ({
  bsStyle = "info",
  children = void 0,
  className = "",
  collapsible = false,
  header = void 0,
  title = "",
  defaultExpanded = false
}) => {
  const defaultHeader = /* @__PURE__ */ React.createElement("h3", null, /* @__PURE__ */ React.createElement(IconHeader, { name: "info" }), title);
  return /* @__PURE__ */ React.createElement(Panel, { defaultExpanded, className: `${styles.helpPanel} ${className}`, bsStyle }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Panel.Title, { toggle: collapsible }, header || defaultHeader)), /* @__PURE__ */ React.createElement(
    ConditionalCollapse,
    {
      condition: collapsible,
      wrapper: (wrapChild) => /* @__PURE__ */ React.createElement(Panel.Collapse, null, wrapChild)
    },
    /* @__PURE__ */ React.createElement(Panel.Body, null, children)
  ));
};
export default HelpPanel;
